import { EuiFlexGroup, EuiFlexItem, EuiTitle } from "@elastic/eui";

export const HomePage = () => {
  return (
    <EuiFlexGroup
      style={{
        height: "100%",
      }}
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <EuiFlexItem grow={false}>
        <EuiTitle size="l">
          <h1>Welcome to Campaign Preview</h1>
        </EuiTitle>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
